import React from 'react'
import './pageHeading.scss'

const PageHeading = ({title}) => {
  return (
    <>

      <div className='page-header-wrapper'>
  <div className='container-wrap'>
    <div className='page-header' style={{ textAlign: 'center' }}>
      <h2>{title}</h2>
      
    </div>
  </div>
</div>

    </>
  )
}

export default PageHeading